import * as client from './client';
export * from './api';
export * from './hooks';
export * from './store';
export * from './translations';
export { client };

// @ts-ignore
window.api = client;
